import React from "react";
import { Grid, Typography } from "@material-ui/core";
import PropTypes from "prop-types";

import { useStyles } from "./styles";
import { Solar, Battery, SadEarth, HappyEarth, Tower } from "../../../resources/images/calculator/svgImages";
import { Utils } from "../../../resources/util";

const kooeeLogo = require("../../../resources/images/nrg-logo.svg");

export default function UserBenefits(props) {
  const classes = useStyles();
  const batteryAndSolar = props.items.includes("battery") && props.items.includes("solar");

  return (
    <Grid item xs={12} className={`${classes.endCalc}`}>
      <Grid container direction="column" justifyContent="center" alignItems="stretch" spacing={0}>
        <Grid item xs={12} className={`${classes.section}`}>
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item xs={9}>
              <Typography>Only from grid</Typography>
              <div className={classes.towerWrapper}>
                <Grid container direction="row" justifyContent="center" alignItems="center">
                  <Grid className={classes.grid} item xs>
                    <div className={classes.panelImageWrapper}>
                      <Tower />
                    </div>
                  </Grid>
                </Grid>
              </div>
              <Typography>$ {Utils.formatCurrency(props.annualBill)} per annum and growing</Typography>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.imageWrapper}>
                <SadEarth />
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item xs={9}>
              <Typography>With NRG Solar</Typography>
              <div className={classes.towerWrapper}>
                <Grid container direction="row" justifyContent="flex-end" alignItems="center">
                  {props.items.map((value, index) => (
                    <Grid
                      item
                      key={index}
                      className={`${index === 0 ? classes.first : classes.mid} ${
                        value === "solar" ? classes.solar : !batteryAndSolar ? classes.battery : classes.batteryWithSolar
                      }`}
                    >
                      <div className={classes.panelImageWrapper}>{value === "solar" ? <Solar /> : <Battery />}</div>
                    </Grid>
                  ))}
                  <Grid className={`${props.items.length === 0 ? classes.only : classes.last} ${batteryAndSolar && classes.reduWIdth}`} item xs>
                    <div className={classes.panelImageWrapper}>
                      <img src={kooeeLogo} alt="NRG" />
                    </div>
                  </Grid>
                </Grid>
              </div>
              <Typography>$ {Utils.formatCurrency(props.bundleAmount)} per month-fixed </Typography>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.imageWrapper}>
                <HappyEarth />
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

UserBenefits.propTypes = {
  setPostal: PropTypes.func,
  sliderProps: PropTypes.object,
  postalCode: PropTypes.oneOfType([PropTypes.string || PropTypes.number]),
  averageBillCal: PropTypes.func,
  estimatedAnnualBill: PropTypes.oneOfType([PropTypes.string || PropTypes.number]),
  didMound: PropTypes.bool,
  items: PropTypes.array,
  annualBill: PropTypes.oneOfType([PropTypes.string || PropTypes.number]),
  bundleAmount: PropTypes.oneOfType([PropTypes.string || PropTypes.number])
};
